import { FC, useMemo } from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

type Props = {
  act: number;
  por: number;
  asi: number;
  otr: number;
};

const RadialBarChart: FC<Props> = ({ act, por, asi, otr }) => {
  const values = [act || 0, por || 0, asi || 0, otr || 0];
  const total = values.reduce((a, b) => a + b, 0);
  const series =
    total > 0 ? values.map((v) => (v / total) * 100) : values.map(() => 0);
  const labels = ['Activadas', 'Portadas', 'Asignadas', 'Otros'];
  const colors = ['#7A4EEA', '#F26522', '#B3B3D3', '#E24C4C'];

  const tooltipFormatter = (val: number, opts?: any) => {
    const index = opts?.seriesIndex;
    if (index === undefined || values[index] === undefined) return '';
    const porcentaje = ((values[index] / total) * 100).toFixed(1);
    return `${values[index]} unidades (${porcentaje}%)`;
  };

  const options: ApexOptions = useMemo(
    () => ({
      chart: {
        type: 'radialBar' as const,
        toolbar: { show: false },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 270,
          hollow: { size: '30%' },
          track: { background: '#EDEDED', margin: 10 },
          dataLabels: {
            show: true,
            name: { show: false },
            value: {
              show: true,
              fontSize: '16px',
              formatter: ((val: number, opts: any) => {
                const index = opts?.seriesIndex;
                if (index === undefined || values[index] === undefined)
                  return '';
                return values[index].toString();
              }) as any,
            },
          },
        },
      },
      labels,
      colors,
      legend: { show: false },
      tooltip: {
        enabled: true,
        theme: 'dark',
        style: { fontSize: '14px' } as any,
        y: { formatter: tooltipFormatter },
      },
    }),
    [values, total]
  );

  return (
    <div
      className="position-relative d-flex justify-content-center align-items-center"
      style={{ width: 290, height: 290 }}
    >
      <Chart
        key={JSON.stringify(values)}
        options={options}
        series={series}
        type="radialBar"
        height={380}
        width={380}
      />
      <div
        className="position-absolute d-flex flex-column justify-content-center"
        style={{
          top: '0%',
          left: '5%',
          textAlign: 'left',
          gap: '1px',
        }}
      >
        {labels.map((label, index) => (
          <div key={index} className="d-flex align-items-center gap-2">
            <div
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: colors[index],
              }}
            ></div>
            <span
              style={{
                fontWeight: 600,
                color: '#0A1E68',
                fontSize: '13px',
              }}
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadialBarChart;
